<template>
  <dash-input-modal
    ref="dashInputModal"
    name="confirm-remove"
    header="Remove market"
    confirm-text="Yes, Remove Market"
    cancel-text="No, Cancel"
  >
    <div slot="contents" class="message">
      Do you want to remove:<br>
      <strong>&ldquo;{{ marketName }}&rdquo;?</strong>
    </div>
  </dash-input-modal>
</template>
<script>
import DashInputModal from '@/components/common/DashInputModal';

export default {
  name: 'ConfirmRemoveModal',
  components: {
    DashInputModal,
  },
  data() {
    return {
      marketName: '',
    };
  },
  methods: {
    confirm(marketName) {
      this.marketName = marketName;
      return this.$refs.dashInputModal.confirm();
    },
  },
};
</script>
<style lang="scss" scoped>
.message {
  line-height: 160%;
}
</style>
